import React from 'react';
import "./blogCard.scss";
import BlogContent from './blogFolder/blogContent';
import { Link } from 'react-router-dom';

const BlogCard = (props) => {
  return (
    <>
      <div className='blogcard'>
        <img className='cardimg' src={props.blogImg} alt="..." />
        <p className='blogheading'>{props.blogHeading}</p>
        <p className='para-text-blog'>{props.blogParagraphs}</p>
        <Link className='readBtnLink' to={props.link}>
          <button className='read-btn'><p>Read more</p></button>
        </Link>
      </div>
    </>
  )
}

export default BlogCard;